import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
// --
import tabs from "./views/tabs.vue";
import VueApexCharts from "vue3-apexcharts";
import utils from "./utils";
const app = createApp(App);
app.config.globalProperties.$util = utils
app.use(router)
  .use(VueApexCharts)
  .component("tabs", tabs)
  .mount("#app");
